module.exports = "<section id=\"genericMessage\" content>\n    <div class=\"container\">\n        <div class=\"logo\"></div>\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{content(titleKey)}}\n        </div>\n        <div class=\"message\" ng-if=\"contentKey\">\n            {{content(contentKey)}}\n        </div>\n    </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ../~/noop-loader!./components/xo-ui-components/src/generic-message/template.html
// module id = ../node_modules/noop-loader/index.js!./components/xo-ui-components/src/generic-message/template.html
// module chunks = 1